import React, { useEffect } from "react";
import { Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContactChat from "../Hellper/ContactChat";

const RoadTransport = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, [location.pathname]); // Triggers when the pathname changes
  const direction = ["ar", "ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ar", "ku"].includes(i18n.language) ? "right" : "left";
  return (
    <Box
      style={{ direction, textAlign }}
      sx={{
        padding: "20px",
        maxWidth: "1100px",
        margin: "auto",
        marginTop: "60px",
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {t("RoadTransport")}
      </Typography>
      {/* Introduction Section */}
      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.4rem",
          "@media (min-width: 1024px)": {
            fontSize: "1.2rem",
          },
        }}
      >
        {t("roadTransportIntro")}
      </Typography>

      {/* Why Choose Our Road Transport Service? */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {t("whyChooseRoadTransport")}
      </Typography>

      <List
        sx={{
          direction, // Sets list direction (rtl or ltr)
        }}
      >
        {[
          t("fastSecureDelivery"),
          t("comprehensiveCoverage"),
          t("flexibleOptions"),
          t("regularDepartures"),
          t("expertTeam"),
        ].map((item, index) => (
          <ListItem key={index} sx={{ padding: "0", marginBottom: "10px" }}>
            <ListItemText
              primary={
                <Typography
                  component="span"
                  sx={{
                    color: "#1D1616",
                    fontSize: {
                      xs: "1.2rem",
                      lg: "1.4rem",
                    },
                    textAlign, // Align text within list item
                    display: "block", // Ensures textAlign applies correctly
                  }}
                >
                  {item}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Key Features of Our Road Transport Services */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {t("keyFeaturesRoadTransport")}
      </Typography>

      <List
        sx={{
          direction, // Sets list direction (rtl or ltr)
        }}
      >
        {[
          t("customSolutions"),
          t("endToEndTracking"),
          t("packagingServices"),
          t("customsClearanceSupport"),
        ].map((item, index) => (
          <ListItem key={index} sx={{ padding: "0", marginBottom: "10px" }}>
            <ListItemText
              primary={
                <Typography
                  component="span"
                  sx={{
                    color: "#1D1616",
                    fontSize: {
                      xs: "1.2rem", // Mobile
                      lg: "1.4rem", // Desktop
                    },
                    textAlign, // Align text within list item
                    display: "block", // Ensures textAlign applies correctly
                  }}
                >
                  {item}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Who Do We Serve? */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {t("whoDoWeServe")}
      </Typography>

      <List
        sx={{
          direction, // Sets list direction (rtl or ltr)
        }}
      >
        {[t("businesses"), t("individuals")].map((item, index) => (
          <ListItem key={index} sx={{ padding: "0", marginBottom: "10px" }}>
            <ListItemText
              primary={
                <Typography
                  component="span"
                  sx={{
                    color: "#1D1616",
                    fontSize: {
                      xs: "1.2rem", // Mobile
                      lg: "1.4rem", // Desktop
                    },
                    textAlign, // Align text within list item
                    display: "block", // Ensures textAlign applies correctly
                  }}
                >
                  {item}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* Get in Touch */}
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          color: "#1e3a8a",
          fontSize: "1.5rem",
          fontWeight: "bold",
          "@media (min-width: 1024px)": {
            fontSize: "1.75rem",
          },
        }}
      >
        {t("getInTouch")}
      </Typography>

      <Typography
        variant="body1"
        paragraph
        sx={{
          color: "#1D1616",
          fontSize: "1.4rem",

          "@media (min-width: 1024px)": {
            fontSize: "1.4rem",
          },
        }}
      >
        {t("readyToShip")}
      </Typography>

      <ContactChat />
    </Box>
  );
};

export default RoadTransport;
